import { useRef } from "react";
import { areArraysEqual, getEffectTarget } from "@lilib/utils";
import useUnmount from "../useUnmount";
function createTargetEffectHook(useHook) {
  return function (effect, deps, targets) {
    var mountedRef = useRef(false);
    var depsRef = useRef([]);
    var deps2Ref = useRef([]);
    var destroyRef = useRef();
    function destroy() {
      var _destroyRef$current;
      (_destroyRef$current = destroyRef.current) === null || _destroyRef$current === void 0 ? void 0 : _destroyRef$current.call(destroyRef);
    }
    useHook(function () {
      var deps2 = targets.map(getEffectTarget);
      function create() {
        depsRef.current = deps;
        deps2Ref.current = deps2;
        destroyRef.current = effect();
      }
      if (mountedRef.current) {
        if (!areArraysEqual(deps, depsRef.current) || !areArraysEqual(deps2, deps2Ref.current)) {
          destroy();
          create();
        }
      } else {
        create();
        mountedRef.current = true;
      }
    });
    useUnmount(function () {
      destroy();
      mountedRef.current = false;
    });
  };
}
export default createTargetEffectHook;